<script>
import moment from 'moment';
import DatePicker from './date_picker';
import { DATE_UI_YEAR_MONTH_SHORT, DATE_UI_YEAR_MONTH_DAY } from '@/constants';

export default {
  extends: DatePicker,

  props: {
    modelValue: { type: Array, default: () => [] },
  },

  data: () => ({
    range: true,
  }),

  computed: {
    valueFormatted() {
      const { modelValue: value } = this;
      return value.map((date) => {
        if (date instanceof moment) {
          return date.toDate();
        }

        return moment(date).toDate();
      });
    },

    format() {
      const { type } = this;
      let format = DATE_UI_YEAR_MONTH_DAY;

      if (type === 'month') {
        format = DATE_UI_YEAR_MONTH_SHORT;
      } else if (type === 'datetime') {
        format = `${DATE_UI_YEAR_MONTH_DAY} HH:mm`;
      } else if (type === 'time') {
        format = 'HH:mm';
      }

      return format;
    },
  },
};
</script>
